import {
  ChevronLeft,
  ChevronRight,
  ZoomIn,
  ZoomOut,
  RotateCcw,
} from "lucide-react";
import { useRef, useState } from "react";

const ViewCarousel = ({
  diagrams,
  index,
  setIndex,
  zoom,
  setZoom,
  resetZoom,
}) => {
  const current = diagrams[index];
  const containerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });
  const [scrollPos, setScrollPos] = useState({ x: 0, y: 0 });
  if (!diagrams || diagrams.length === 0) {
    return (
      <div className=" text-black text-center font-bold text-lg">
        No ER diagrams found
      </div>
    );
  }

  const handleMouseDown = (e) => {
    if (zoom <= 1) return;

    setIsDragging(true);
    setStartPos({ x: e.clientX, y: e.clientY });
    setScrollPos({
      x: containerRef.current.scrollLeft,
      y: containerRef.current.scrollTop,
    });
  };

  const handleMouseMove = (e) => {
    if (!isDragging || zoom <= 1) return;

    const dx = e.clientX - startPos.x;
    const dy = e.clientY - startPos.y;

    containerRef.current.scrollLeft = scrollPos.x - dx;
    containerRef.current.scrollTop = scrollPos.y - dy;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  return (
    <>
      <div className="bg-indigo-100 px-4 py-4 rounded-md">
        <div className="bg-white p-4  rounded-md mb-4">
          <h3 className="font-bold text-[16px] text-black">
            {current?.description}
          </h3>
        </div>
        <div className="bg-gray-100  rounded-xl overflow-hidden">
          {/* <div className="relative py-2 flex flex-col items-center justify-center"> */}
          <div className="relative py-2 flex flex-col items-center justify-center min-h-[70vh]">
            <div
              ref={containerRef}
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUp}
              onMouseLeave={handleMouseUp}
              className={`w-full h-full overflow-auto bg-gray-100 rounded-lg
                ${zoom > 1 ? "cursor-grab active:cursor-grabbing" : ""}
              `}
              
            >
              <img
                src={current?.preview}
                alt={current?.name}
                draggable={false}
                className="object-contain transition-all duration-200 select-none"
                style={{
                  width: `${zoom * 100}%`,
                  height: "auto",
                  maxWidth: "none",
                }}
              />
            </div>
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 
                flex items-center gap-4 
                bg-white/90 px-4 py-2 rounded-full shadow">

            <button
              disabled={index === 0}
              onClick={() => setIndex((i) => Math.max(i - 1, 0))}
              className={`p-1 rounded-full transition text-black
                ${index === 0 ? "opacity-40 cursor-not-allowed" : "hover:bg-gray-200"}`}
            >
              <ChevronLeft size={22} />
            </button>

            <span className="text-sm font-medium text-black whitespace-nowrap">
              Showing Design Diagrams {index + 1} of {diagrams.length}
            </span>

            <button
              disabled={index === diagrams.length - 1}
              onClick={() => setIndex((i) => Math.min(i + 1, diagrams.length - 1))}
              className={`p-1 rounded-full transition text-black
                ${index === diagrams.length - 1 ? "opacity-40 cursor-not-allowed" : "hover:bg-gray-200"}`}
            >
              <ChevronRight size={22} />
            </button>
          </div>


            {/* Navigation */}
            <button
              disabled={index === 0}
              onClick={() => setIndex((i) => Math.max(i - 1, 0))}
              className={`absolute -left-3  p-2 rounded-full shadow bg-white text-black
              ${index === 0 ? "opacity-40 cursor-not-allowed" : ""}`}
            >
              <ChevronLeft size={28} />
            </button>

            <button
              disabled={index === diagrams.length - 1}
              onClick={() =>
                setIndex((i) => Math.min(i + 1, diagrams.length - 1))
              }
              className={`absolute -right-3  p-2 rounded-full shadow bg-white text-black
              ${index === diagrams.length - 1 ? "opacity-40 cursor-not-allowed" : ""}`}
            >
              <ChevronRight size={28} />
            </button>

            {/* Controls */}
            <div className=" text-black absolute bottom-4 right-4 flex gap-2 bg-white bg-opacity-80 p-2 rounded-full shadow">
              <button onClick={() => setZoom((z) => Math.max(1, z - 0.5))}>
                <ZoomOut />
              </button>
              <button onClick={() => setZoom((z) => Math.min(5, z + 0.5))}>
                <ZoomIn />
              </button>
              <button onClick={resetZoom}>
                <RotateCcw />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewCarousel;
